import React from 'react';
import './CategoryGrid.css';

const CategoryGrid = ({ categories, onCategoryClick }) => {
  return (
    <div className="category-grid">
      {categories.map(category => (
        <div
          key={category.id}
          className="category-card"
          onClick={() => onCategoryClick(category.id)}
            style={{ backgroundImage: `url(${category.backgroundImage})` }}
          /*style={{ '--category-color': category.color }}*/
        >
          <div className="category-icon" style={{ backgroundColor: category.color }}>
            {category.icon}
          </div>
          <h4 className="category-name">{category.name}</h4>
        </div>
      ))}
    </div>
  );
};

export default CategoryGrid;